import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

// core components
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Card from 'components/Card/Card.js'
import CardBody from 'components/Card/CardBody.js'
import CardHeader from 'components/Card/CardHeader'

import styles from 'assets/jss/material-kit-react/views/indexPageSections/peopleStyle.js'

import library from 'assets/img/indexPage/library.jpg'
import workplace from 'assets/img/indexPage/workplace.jpg'
import london from 'assets/img/indexPage/london.jpg'

const useStyles = makeStyles(styles)

export default function PeopleSection() {
  const classes = useStyles()
  const imageClasses = classNames(classes.imgRaised, classes.imgRounded, classes.imgFluid)
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>人才多元化</h2>
          <h5 className={classes.description}>推进可持续成长的人才多元化与包容性，让每一位员工都能将能力发挥到极致</h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <Card>
              <CardHeader className={classes.itemGrid}>
                <img src={library} alt="业绩类型丰富多样" className={imageClasses} />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>业绩类型丰富多样</h4>
                <p className={classes.description}>
                  具有丰富的咨询服务经验及业绩成果，熟悉住宅、大型办公商业区、医院、学校等各类型项目全过程技术服务。
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card>
              <CardHeader className={classes.itemGrid}>
                <img src={workplace} alt="专业齐全实力雄厚" className={imageClasses} />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>专业齐全实力雄厚</h4>
                <p className={classes.description}>
                  团队成员主要由南大、东大、同济、哈工大、河海等著名高校王牌专业的高层次人才组成，
                  专业涉及暖通、给排水、建筑节能、景观设计、环境工程、市政工程、热能动力等。
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card>
              <CardHeader className={classes.itemGrid}>
                <img src={london} alt="资质涉及领域全面" className={imageClasses} />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>资质涉及领域全面</h4>
                <p className={classes.description}>具备设计、检测、咨询、施工等方面专业资质认证人员，可在各个方面为业主方提供指导。</p>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  )
}
